


import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Location } from 'vue-router';

@Component({})
export default class SummaryNavigation extends Vue {
  @Prop() private links!: Location[];
  @Prop({ default: false }) private fontsLoaded!: boolean;

  private mounted() {
    this.updateIndicatorPosition();
  }

  private updateIndicatorPosition(el: HTMLElement | null = this.$el.querySelector('.-active')) {
    if (el) {
      (this.$el as HTMLElement).style.setProperty('--width', el.clientWidth.toString() + 'px');
      (this.$el as HTMLElement).style.setProperty('--left', el.offsetLeft.toString() + 'px');
    }
  }

  @Emit()
  private navigation(link: Location, index: number) {
    return { link, index };
  }

  @Watch('$route')
  private async routeChanged() {
    await this.$nextTick();
    this.updateIndicatorPosition();
  }

  @Watch('fontsLoaded')
  private async fontsLoadedStatusChanged(to: boolean) {
    if (to) this.updateIndicatorPosition();
  }
}
